(function(){
  const style = document.createElement('style');
  style.textContent = `
    @keyframes mewaramCartSpin{to{transform:rotate(360deg)}}
    .cart-item.mewaram-cart-updating .qty{position:relative}
    .cart-item.mewaram-cart-updating .qty input{color:transparent!important;caret-color:transparent!important}
    .cart-item.mewaram-cart-updating .qty::after{content:"";position:absolute;left:50%;top:50%;width:16px;height:16px;margin:-8px 0 0 -8px;border:2px solid rgba(53,19,6,.18);border-top-color:#351306;border-radius:50%;animation:mewaramCartSpin .65s linear infinite;pointer-events:none}
    .cart-item.mewaram-cart-updating .price{position:relative;color:transparent!important;min-height:22px}
    .cart-item.mewaram-cart-updating .price::after{content:"";position:absolute;left:50%;top:50%;width:16px;height:16px;margin:-8px 0 0 -8px;border:2px solid rgba(53,19,6,.18);border-top-color:#351306;border-radius:50%;animation:mewaramCartSpin .65s linear infinite}
    .mewaram-cart-combo.mewaram-cart-updating{pointer-events:none;opacity:.68}
    .mewaram-cart-combo.mewaram-cart-updating::after{content:"";position:absolute;left:50%;top:50%;z-index:4;width:24px;height:24px;margin:-12px 0 0 -12px;border:3px solid rgba(53,19,6,.18);border-top-color:#351306;border-radius:50%;animation:mewaramCartSpin .65s linear infinite}
    .cart-layout.mewaram-cart-busy .qty button,.cart-layout.mewaram-cart-busy .qty input,.cart-layout.mewaram-cart-busy .cart-remove,.cart-layout.mewaram-cart-busy [data-remove-combo],.cart-layout.mewaram-cart-busy button[name="update"],.cart-layout.mewaram-cart-busy button[name="checkout"]{cursor:wait!important}
    .cart-layout.mewaram-cart-busy .cart-remove{pointer-events:none;opacity:.55}
  `;
  document.head.appendChild(style);

  const cardSyncStates = new Map();
  let visibleCartCount = Number(document.querySelector('[data-cart-count], .cart-count')?.textContent || 0);
  let reconcileTimer = null;

  function updateVisibleCartCount(count){
    visibleCartCount = Math.max(0, Number(count || 0));
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => el.textContent = visibleCartCount);
    document.querySelectorAll('[data-floating-count]').forEach(el => el.textContent = visibleCartCount);
    const floating = document.querySelector('[data-floating-cart]');
    if(floating) floating.classList.toggle('show', visibleCartCount > 0);
  }

  function toast(message){
    if(typeof window.showToast === 'function'){
      window.showToast(message);
      return;
    }
    const el = document.querySelector('[data-toast]');
    if(!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => el.classList.remove('show'), 1700);
  }

  function renderVariantQty(variantId, qty){
    document.querySelectorAll(`[data-variant-chip][data-variant-id="${CSS.escape(String(variantId))}"]`).forEach(chip => {
      chip.dataset.quantity = String(Math.max(0, Number(qty || 0)));
      const card = chip.closest('[data-product-card]');
      if(card && typeof card._mewaramUpdateCard === 'function') card._mewaramUpdateCard();
    });
  }

  function stateFor(variantId, fallbackQty){
    const id = String(variantId);
    if(!cardSyncStates.has(id)){
      const qty = Math.max(0, Number(fallbackQty || 0));
      cardSyncStates.set(id, {desired:qty, server:qty, timer:null, inFlight:false});
    }
    return cardSyncStates.get(id);
  }

  function hasPendingCardSync(){
    for(const state of cardSyncStates.values()){
      if(state.inFlight || state.timer || state.desired !== state.server) return true;
    }
    return false;
  }

  function aggregateVariantQty(cart){
    const map = new Map();
    (cart?.items || []).forEach(item => {
      const id = String(item.variant_id);
      map.set(id, (map.get(id) || 0) + Number(item.quantity || 0));
    });
    return map;
  }

  function hydrateCardsFromCart(cart, forceDesired){
    const quantities = aggregateVariantQty(cart);
    document.querySelectorAll('[data-variant-chip]').forEach(chip => {
      const id = String(chip.dataset.variantId || '');
      if(!id) return;
      const qty = quantities.get(id) || 0;
      const state = stateFor(id, qty);
      state.server = qty;
      if(forceDesired || (!state.inFlight && !state.timer && state.desired === state.server)) state.desired = qty;
      renderVariantQty(id, state.desired);
    });
    if(!hasPendingCardSync()) updateVisibleCartCount(cart?.item_count || 0);
  }

  async function fetchCart(){
    const res = await fetch('/cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
    if(!res.ok) throw new Error('Unable to load cart');
    return res.json();
  }

  function scheduleReconcile(delay){
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(async () => {
      if(hasPendingCardSync()){
        scheduleReconcile(90);
        return;
      }
      try{
        const cart = await fetchCart();
        hydrateCardsFromCart(cart, true);
        updateVisibleCartCount(cart.item_count || 0);
      }catch(e){}
    }, typeof delay === 'number' ? delay : 100);
  }

  async function flushVariant(variantId){
    const id = String(variantId);
    const state = cardSyncStates.get(id);
    if(!state || state.inFlight) return;
    state.timer = null;

    const target = Math.max(0, Number(state.desired || 0));
    const serverQty = Math.max(0, Number(state.server || 0));
    if(target === serverQty){
      scheduleReconcile(80);
      return;
    }

    state.inFlight = true;
    const sentQty = target;
    try{
      let response;
      if(serverQty === 0 && sentQty > 0){
        response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:[{id:Number(id), quantity:sentQty}]})
        });
      }else{
        response = await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({id:id, quantity:sentQty})
        });
      }
      if(!response.ok) throw new Error('Cart update failed');
      const result = await response.json();
      state.server = sentQty;
      if(result && typeof result.item_count === 'number' && state.desired === sentQty) updateVisibleCartCount(result.item_count);
    }catch(e){
      state.inFlight = false;
      toast('Cart update failed. Syncing again.');
      scheduleReconcile(0);
      return;
    }

    state.inFlight = false;
    if(state.desired !== state.server){
      flushVariant(id);
    }else{
      scheduleReconcile(80);
    }
  }

  function queueVariant(variantId){
    const id = String(variantId);
    const state = cardSyncStates.get(id);
    if(!state) return;
    clearTimeout(state.timer);
    state.timer = setTimeout(() => flushVariant(id), 110);
  }

  function optimisticCardQty(card, variantId, nextQty){
    const id = String(variantId);
    const activeChip = card.querySelector(`[data-variant-chip][data-variant-id="${CSS.escape(id)}"]`);
    const fallback = Number(activeChip?.dataset.quantity || 0);
    const state = stateFor(id, fallback);
    const current = state.desired;
    const next = Math.max(0, Number(nextQty || 0));
    state.desired = next;
    updateVisibleCartCount(visibleCartCount + (next - current));
    renderVariantQty(id, next);
    queueVariant(id);
  }

  function handleCardControl(event, button){
    const card = button.closest('[data-product-card]');
    if(!card) return false;
    const chip = card.querySelector('[data-variant-chip].active') || card.querySelector('[data-variant-chip]');
    if(!chip || chip.dataset.available === 'false') return true;
    const id = String(chip.dataset.variantId || '');
    if(!id) return true;
    const state = stateFor(id, Number(chip.dataset.quantity || 0));
    let next = state.desired;
    if(button.matches('[data-card-add]')) next = Math.max(1, state.desired || 0);
    if(button.matches('[data-card-plus]')) next = state.desired + 1;
    if(button.matches('[data-card-minus]')) next = Math.max(0, state.desired - 1);
    optimisticCardQty(card, id, next);
    if(button.matches('[data-card-add]')) toast('Added to cart');
    return true;
  }

  function cartContext(){
    const layout = document.querySelector('.cart-layout');
    if(!layout) return null;
    const wrapper = layout.closest('[id^="shopify-section-"]');
    const sectionId = wrapper?.id ? wrapper.id.replace(/^shopify-section-/, '') : '';
    return {layout, wrapper, sectionId};
  }

  function lineKeyFromInput(input){
    const match = String(input?.name || '').match(/^updates\[(.*)\]$/);
    return match ? match[1] : '';
  }

  function setCartBusy(context, busy){
    if(!context?.layout) return;
    context.layout.classList.toggle('mewaram-cart-busy', busy);
    context.layout.querySelectorAll('.qty button,.qty input,[data-remove-combo],button[name="update"],button[name="checkout"]').forEach(el => {
      el.disabled = !!busy;
    });
    context.layout.querySelectorAll('.cart-remove').forEach(el => {
      el.setAttribute('aria-disabled', busy ? 'true' : 'false');
    });
  }

  function sectionUrl(){
    return window.location.pathname + window.location.search;
  }

  function replaceRenderedCart(context, cart, html, noteValue){
    updateVisibleCartCount(cart?.item_count || 0);
    if(!context?.wrapper || !html){
      window.location.reload();
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const returnedWrapper = context.sectionId ? doc.getElementById(`shopify-section-${context.sectionId}`) : null;
    context.wrapper.innerHTML = returnedWrapper ? returnedWrapper.innerHTML : doc.body.innerHTML;

    const note = document.querySelector('#CartNote');
    if(note && typeof noteValue === 'string') note.value = noteValue;
  }

  async function changeCartLine(key, quantity, updatingElement){
    const context = cartContext();
    if(!context || context.layout.classList.contains('mewaram-cart-busy')) return;
    const noteValue = document.querySelector('#CartNote')?.value || '';
    updatingElement?.classList.add('mewaram-cart-updating');
    setCartBusy(context, true);

    try{
      const payload = {id:key, quantity:Math.max(0, Number(quantity || 0))};
      if(context.sectionId){
        payload.sections = [context.sectionId];
        payload.sections_url = sectionUrl();
      }
      const res = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify(payload)
      });
      if(!res.ok) throw new Error('Cart update failed');
      const cart = await res.json();
      const html = context.sectionId ? cart.sections?.[context.sectionId] : null;
      if(html){
        replaceRenderedCart(context, cart, html, noteValue);
      }else{
        updateVisibleCartCount(cart.item_count || 0);
        window.location.reload();
      }
    }catch(e){
      updatingElement?.classList.remove('mewaram-cart-updating');
      setCartBusy(context, false);
      toast('Could not update cart. Please try again.');
    }
  }

  async function removeCombo(button){
    const context = cartContext();
    if(!context || context.layout.classList.contains('mewaram-cart-busy')) return;
    const combo = button.closest('[data-cart-combo-card]');
    const comboId = String(button.dataset.comboId || combo?.dataset.comboId || '');
    if(!comboId) return;
    const noteValue = document.querySelector('#CartNote')?.value || '';
    combo?.classList.add('mewaram-cart-updating');
    setCartBusy(context, true);

    try{
      const current = await fetchCart();
      const updates = {};
      (current.items || []).forEach(item => {
        if(String(item.properties?._combo_id || '') === comboId) updates[item.key] = 0;
      });
      if(!Object.keys(updates).length) throw new Error('Combo not found');

      const payload = {updates};
      if(context.sectionId){
        payload.sections = [context.sectionId];
        payload.sections_url = sectionUrl();
      }
      const res = await fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify(payload)
      });
      if(!res.ok) throw new Error('Combo removal failed');
      const cart = await res.json();
      const html = context.sectionId ? cart.sections?.[context.sectionId] : null;
      if(html){
        replaceRenderedCart(context, cart, html, noteValue);
      }else{
        updateVisibleCartCount(cart.item_count || 0);
        window.location.reload();
      }
    }catch(e){
      combo?.classList.remove('mewaram-cart-updating');
      setCartBusy(context, false);
      toast('Could not remove combo. Please try again.');
    }
  }

  document.addEventListener('click', function(event){
    const cardButton = event.target.closest('[data-card-add],[data-card-plus],[data-card-minus]');
    if(cardButton && cardButton.closest('[data-product-card]')){
      event.preventDefault();
      event.stopPropagation();
      handleCardControl(event, cardButton);
      return;
    }

    const cartButton = event.target.closest('.cart-layout [data-qty-plus],.cart-layout [data-qty-minus]');
    if(cartButton){
      event.preventDefault();
      event.stopPropagation();
      const item = cartButton.closest('.cart-item');
      const input = item?.querySelector('.qty input[name^="updates["]');
      const key = lineKeyFromInput(input);
      if(!item || !input || !key) return;
      const current = Math.max(0, Number(input.value || 0));
      const next = cartButton.matches('[data-qty-minus]') ? Math.max(0, current - 1) : current + 1;
      if(next !== current) changeCartLine(key, next, item);
      return;
    }

    const remove = event.target.closest('.cart-layout .cart-remove');
    if(remove){
      event.preventDefault();
      event.stopPropagation();
      const item = remove.closest('.cart-item');
      const input = item?.querySelector('.qty input[name^="updates["]');
      const key = lineKeyFromInput(input);
      if(item && key) changeCartLine(key, 0, item);
      return;
    }

    const comboRemove = event.target.closest('.cart-layout [data-remove-combo]');
    if(comboRemove){
      event.preventDefault();
      event.stopPropagation();
      removeCombo(comboRemove);
    }
  }, true);

  document.addEventListener('change', function(event){
    const input = event.target.closest('.cart-layout .qty input[name^="updates["]');
    if(!input) return;
    const item = input.closest('.cart-item');
    const key = lineKeyFromInput(input);
    if(!item || !key) return;
    const next = Math.max(0, Number(input.value || 0));
    changeCartLine(key, next, item);
  }, true);

  fetchCart().then(cart => {
    hydrateCardsFromCart(cart, true);
    updateVisibleCartCount(cart.item_count || 0);
  }).catch(() => {});
})();
